import { Box, Button, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { updateBasicCalculator } from "../../redux/features/basicCalculator";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export const BasicCalculatorResponse = () => {
  const state = useSelector((state) => state.basicCalculatorState);
  const dispatch = useDispatch();

  const handleCalculatorState = () => {
    dispatch(updateBasicCalculator({ state: 0 }));
  };

  const colors = {
    success: "#C8E6C9", // light green
    warning: "#FFF9C4", // soft yellow
    error: "#FFE0B2", // soft orange
    critical: "#FFCDD2", // light red
  };

  const LabelResult = ({ label, value }) => (
    <Box display="flex" justifyContent="space-between">
      <Typography variant="subtitle1">{label}</Typography>
      <Typography variant="subtitle2">{value}</Typography>
    </Box>
  );

  return (
    <Box
      sx={{
        position: "relative", 
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100%",
        width: "90%",
        padding: 4,
        m: 5,
        ml: 8,
        mt: 10,
        border: "1px solid var(--fx-surface-borderstrong, #CBD5E1)",
        borderRadius: 2,
      }}
    >
      <Button
        onClick={handleCalculatorState}
        sx={{
          position: "absolute",
          top: 16,
          left: 16,
          minWidth: "auto",
          padding: 1,
        }}
      >
        <ArrowBackIcon />
      </Button>

      <Typography variant="h6" textAlign="center" mb={2}>
        Summary
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          mt: 4,
          width: "100%",
        }}
      >
        <LabelResult
          label={"Hourly Rate"}
          value={`$${state.billingHourlyRate}`}
        />
        <LabelResult label={"COGS"} value={`$${state.cogs}`} />
        <LabelResult
          label={"Gross Profit Amount"}
          value={`$${parseFloat(state.grossProfitAmount).toFixed(2)}`}
        />

        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
          <Typography variant="subtitle1">Status</Typography>
          <Box
            sx={{
              px: 2,
              py: 0.5, 
              bgcolor: colors[state.status],
              borderRadius: 1,
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                color: "var(--fx-surface-text, #0F172A)",
                textTransform: "capitalize",
                fontWeight: "bold",
              }}
            >
              {state.status === "error" ? "Problem" : state.status}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
